import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Model, { onChange as onChangeModel } from '../../lib/Model'

import { H2, Form, Field, Input, Note, Button } from '../Common'

import style from './Form.scss'

class FormChangePassword extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
  }

  state = {
    form: {
      submitted: false,
      loading: false,
      password: new Model('password', '', 'password'),
      passwordConfirm: new Model('passwordConfirm', '', 'password'),
    },
  }

  onChange = (event, model) => {
    this.setState(onChangeModel(model))
  }

  handleSubmit = () => {
    const { password, passwordConfirm } = this.state.form
    const notEqualsPassword = password.valid && passwordConfirm.valid && password.value !== passwordConfirm.value

    this.setState((state) => ({
      ...state,
      form: {
        ...state.form,
        submitted: true,
        notEqualsPassword,
      },
    }))

    if (this.props.loading || password.invalid || passwordConfirm.invalid || notEqualsPassword) {
      return
    }

    if (password.value !== passwordConfirm.value) {
      return
    }

    this.props.onSubmit({
      password: password.value,
      passwordConfirm: passwordConfirm.value,
    })
  }

  render() {
    const { loading } = this.props
    const { submitted, password, passwordConfirm, notEqualsPassword } = this.state.form

    const passwordRequiredInvalid = password.error.required
    const passwordMinLengthInvalid = !password.error.required && password.error.minLength
    const passwordInvalid = passwordRequiredInvalid || passwordMinLengthInvalid

    const passwordConfirmRequiredInvalid = passwordConfirm.error.required
    const passwordConfirmMinLengthInvalid = !passwordConfirm.error.required && password.error.minLength
    const passwordConfirmInvalid = passwordConfirmRequiredInvalid || passwordConfirmMinLengthInvalid

    return (
      <div className={style.wrapper}>
        <H2 className={style.h2}>recuperar senha</H2>
        <Form onSubmit={this.handleSubmit} className={style.form}>
          <Field label="nova senha" className={style.field}>
            <Input
              model={password}
              onChange={this.onChange}
              invalid={submitted && passwordInvalid}
              size="xl"
              required
              minLength={5}
              tabIndex={0}
              autoFocus
            />
            <Note error show={submitted && passwordRequiredInvalid}>
              campo obrigatório
            </Note>
            <Note error show={submitted && passwordConfirmMinLengthInvalid}>
              a senha deve conter o mínimmo de 5 caracteres
            </Note>
          </Field>
          <Field label="repita a nova senha" className={style.field}>
            <Input
              model={passwordConfirm}
              onChange={this.onChange}
              invalid={submitted && passwordConfirmInvalid}
              size="xl"
              required
              tabIndex={0}
            />
            <Note error show={submitted && passwordConfirmRequiredInvalid}>
              campo obrigatório
            </Note>
          </Field>
          <Button loading={loading} submit theme="greenDecide" xl>
            salvar
          </Button>
          <Note error show={submitted && notEqualsPassword}>
            as senhas estão diferentes
          </Note>
        </Form>
      </div>
    )
  }
}

export default FormChangePassword



// WEBPACK FOOTER //
// ./src/components/ChangePassword/Form.js